module.exports = __webpack_public_path__ + "static/media/search-icon.01d34a9b.svg";